"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _createSvgIcon = _interopRequireDefault(require("./utils/createSvgIcon"));

var _jsxRuntime = require("react/jsx-runtime");

var _default = (0, _createSvgIcon.default)([/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "m20.41 11.36-.35-.35a.9959.9959 0 0 0-1.41 0c-.39.39-.39 1.02 0 1.41l.35.35-4.24 4.24-7.78-7.78 4.24-4.24.35.35c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41l-.35-.36c-.79-.79-2.03-.79-2.82 0L5.57 7.82c-.78.78-.78 2.05 0 2.83l7.78 7.78c.79.79 2.03.79 2.82 0l4.24-4.24c.79-.78.79-2.05 0-2.83zm-9.56 6.49c-.31-.31-.85-.09-.85.36v1.53c-3.17-.82-5.59-3.54-5.95-6.86-.06-.51-.49-.88-.99-.88-.6 0-1.07.53-1 1.12C2.62 18.11 6.87 22 12 22c.59 0 1.17-.06 1.73-.16.4-.07.55-.56.27-.85l-3.15-3.14z"
}, "0"), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M16 9h4c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1v-.89c0-1-.68-1.92-1.66-2.08C17.08.82 16 1.79 16 3v1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1zm1-6c0-.55.45-1 1-1s1 .45 1 1v1h-2V3z"
}, "1")], 'ScreenLockRotationRounded');

exports.default = _default;